<template>
  <v-flex>
    <!-- NEW POPUP-->
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newOpDialog"
      persistent
      max-width="1200px"
    >
      <Edit
        :sync="sync"
        :close="close"
        :name="newOp.name"
        :text="newOp.text"
        :applyOnPortal="newOp.applyOnPortal"
        :applyLink="newOp.applyLink"
        title="New Opportunity"
      ></Edit>
    </v-dialog>
    <v-card class="pa-md-5 pb-5" elevation="2">
      <v-card-title>Sponsors portal opportunities</v-card-title>
      <v-card-text v-html="config.instructions"> </v-card-text>
      <v-fab-transition>
        <v-btn
          v-show="applyOnPortal"
          fab
          dark
          bottom
          large
          right
          absolute
          color="success"
          @click="createNew"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card>
    <br />
    <v-flex class="my-5">
      <v-layout wrap>
        <v-layout row v-if="sponsor.opportunities.length > 1">
          <v-flex xs12 px-3>
            <v-text-field
              v-model="search"
              outlined
              prepend-inner-icon="search"
              label="Search through your opportunities"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-flex
          v-for="opportunity in filteredOpportunities"
          :key="opportunity['.uid']"
          xs12
          my-2
        >
          <Opportunity :opportunity="opportunity"></Opportunity>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>
import Opportunity from "../Opportunity";
import { db } from "@/plugins/firebase";
import Edit from "../Edit2";

export default {
  fiery: true,
  components: { Opportunity, Edit },
  props: ["sponsor"],
  data: function() {
    return {
      applyLink: this.sponsor.applyLink,
      config: this.$fiery(db.collection("Portal").doc("opportunities")),
      applyOnPortal: this.sponsor.enableOpportunities,
      search: "",
      newOp: {
        name: "",
        text: "",
        applyOnPortal: false,
        applyLink: ""
      },
      newOpDialog: false
    };
  },
  watch: {
    applyOnPortal(is) {
      if (is) {
        this.sponsor.enableOpportunities = true;
        this.$fiery.sync(this.sponsor);
      } else {
        this.sponsor.enableOpportunities = false;
        this.$fiery.sync(this.sponsor);
      }
    },
    applyLink(link) {
      this.sponsor.applyLink = link;
      this.$fiery.sync(this.sponsor);
    }
  },
  computed: {
    filteredOpportunities() {
      return this.sponsor.opportunities
        .filter(o => !o.deleted)
        .filter(o => this.filterfunc(o));
    }
  },
  methods: {
    filterfunc: function(o) {
      if (!this.search) {
        return true;
      }
      let searchParams = this.search.split(" ");
      let flag = false;
      searchParams.forEach(s => {
        if (o.name.toLowerCase().includes(s.toLowerCase())) {
          flag = true;
        }
      });
      return flag;
    },
    createNew: function() {
      this.newOp = this.$fiery.buildSub(this.sponsor, "opportunities", {
        name: "",
        text: "",
        applyOnPortal: false,
        applyLink: "",
        open: true,
        deleted: false
      });
      this.newOpDialog = true;
    },
    sync(name, text, applyOnPortal, applyLink) {
      this.newOp.name = name;
      this.newOp.text = text;
      this.newOp.applyOnPortal = applyOnPortal;
      this.newOp.applyLink = applyLink;
      this.$fiery.save(this.newOp);
      this.newOpDialog = false;
    },
    close() {
      this.$fiery.remove(this.newOp);
      this.newOpDialog = false;
    }
  }
};
</script>
